import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class PiratesHideout3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.PIRATES_HIDEOUT3;
}

export default PiratesHideout3PoiTileEntity;
